import React, {useState, useEffect, useContext} from 'react';
import './style.scss';
import Tabs from './Tabs';
import { Switch } from 'react-router';
import PrivateRoute from 'components/PrivateRoute';
import InputRoute from './InputRouter'
import { getOriginalSite, refreshFile } from 'utils/api';
import VisualSelector from '../VisualSelector/index';
import { toast } from 'react-toastify';
import { logout } from 'redux/modules/auth/action';
import { connect } from 'react-redux';
import {useHistory} from 'react-router-dom';
import {ErrorContext} from 'contexts/ErrorContext';

function InputsHandler(props) {
    let history = useHistory();
    const {handleErrors} = useContext(ErrorContext);

    const [selectedTab, setSelectedTab] = useState('');
    const [isVSReady, setIsVSReady] = useState(false);
    const [dataForVS, setDataForVS] = useState(null);
    const [loading, handleLoading] = useState(false);

    useEffect(() => {
        let url = history.location.pathname;
        if(url.includes('preview')) {
            setIsVSReady(true);
        } else {
            setIsVSReady(false);
            if(url === '/' || url === '/main' || url === '/main/') {
                history.push('/main/globe');
            } else {
                setSelectedTab(guessModeBasedOnUrl(url));
            }
        }
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history, history.location.pathname]);

    const guessModeBasedOnUrl = (url) => {
        if(url.includes('globe')){
            return 'globe';
        } else if(url.includes('twitter')) {
            return 'twitter';
        } else if(url.includes('facebook')) {
            return 'facebook';
        } else if(url.includes('youtube')) {
            return 'youtube';
        } else if(url.includes('rss')) {
            return 'rss';
        } else if(url.includes('instagram')) {
            return 'instagram';
        } else {
            history.push('/main/globe');
        }
    }

    const getTemplate = async (inputValue) => {
        const path = inputValue.trim();
        handleLoading(true);
        const params = {
            url: path,
            url_response: true,
            html_response: !process.env.production ? true : false,
            usage_js: false,
        };

        try {
            const data = await getOriginalSite(params);
            !process.env.production && (await refreshFile(data.html));
            data.path = path;

            //For case when we don't have resource in DB and backend don't give usage_js variable
            if(data.usage_js === undefined || data.usage_js === null) {
                data.usage_js = false;
            }
            setDataForVS({ ...data, path });
            
            setIsVSReady(true);
            history.push('/main/preview');
        } catch (err) {
            console.log(err)
            handleErrors(err);
            handleLoading(false);
        }
        handleLoading(false);
    };

    /*const urlConvert = (url) => {
        if (url.search('http') !== -1 || url.search(/\./) === -1) {
            return url;
        }
        return `http://${url}`;
    };*/
    
    return isVSReady ? (
        <Switch>
            <PrivateRoute canEnter={true} exact path="/main/preview" component={VisualSelector} routerBridgeProps={dataForVS}/>
            <PrivateRoute canEnter={true} exact path="/main/preview/:id" component={VisualSelector} />
        </Switch>
    ) : (
        <div className="target_input">
            <div className="target_input-container">
                <Tabs setSelectedTab={setSelectedTab} active={selectedTab} history={history} />
                <InputRoute {...props} onSubmit={getTemplate} loading={loading} />
            </div>
        </div>
    );
}

const mapStateFromProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateFromProps, { logout })(InputsHandler);